import { Button } from "@smart/itops-sb-design-system-dom";

export const embedTypes = ["url", "iframe", "button"] as const;

export type EmbedType = (typeof embedTypes)[number];

const options: Record<
  EmbedType,
  {
    title: string;
    description: string;
    button: string;
  }
> = {
  url: {
    title: "Link",
    description: "Directly share a link to this form.",
    button: "Copy Link",
  },
  iframe: {
    title: "Embedded",
    description: "Embed this form in your website.",
    button: "Copy Code",
  },
  button: {
    title: "'Contact Us' Button",
    description: "Add a Contact Us button to your website.",
    button: "Copy Code",
  },
};

export type EmbedOptionProps = {
  disabled?: boolean;
  onCopy: (type: EmbedType) => Promise<void>;
};

export const EmbedOptions = ({ disabled, onCopy }: EmbedOptionProps) => (
  <div className="flex flex-col gap-medium">
    {embedTypes.map((type) => (
      <div className="flex gap-medium" key={type}>
        <div className="flex justify-between w-full gap-xSmall align-center">
          <div className="flex flex-col align-center gap-xSmall">
            <p className="text-ui font-semibold">{options[type].title}</p>
            <p>{options[type].description}</p>
          </div>
          <div>
            <Button
              variant="secondaryDefault"
              leftIcon="regularCopy"
              onClick={() => onCopy(type)}
              text={options[type].button}
              data-testid={`copy-${type}`}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    ))}
  </div>
);
